<template>
  <main>
    <div style="background-color: white">
      <div class="service">
        <gradientAnimation />
        <div class="content">
          <div>
            <h1 :class="{ 'is-en': isEnglishLocale }">{{ $t('compliance.heroTitle') }}</h1>
            <h2 v-html="$t('compliance.heroBody')"></h2>
            <div class="action">
              <a class="button" :href="`${this.clientUrl}/auth/register`" target="_blank">
                <span>{{ $t('common.startNow') }}</span>
                <div class="arrowBox">
                  <span class="arrow">
                    <i /><i /><i />
                  </span>
                </div>
              </a>
              <router-link class="button" to="/customer" target="_blank">
                <span>{{ $t('common.contactUs') }}</span>
                <span class="arrow">
                  <i /><i /><i />
                </span>
              </router-link>
            </div>
          </div>

          <div class="images">
            <img src="@/assets/images/Compliance/point.png">
            <img src="@/assets/images/Compliance/supervision-1.png" style="border-radius: 20px;">
            <img src="@/assets/images/Compliance/supervision-2.png">
          </div>
        </div>
      </div>
      <div class="safe diagonal">
        <div class="content">
          <div>
            <h3>{{ $t('compliance.safeTitle') }}</h3>
            <p v-html="$t('compliance.safeBody')"></p>
            <ul class="img-list">
              <li v-for="(item, index) in safeItems" :key="item.title">
                <img :src="safeIcons[index]" alt="Safe" />
                <h5>{{ item.title }}</h5>
                <p v-html="item.desc"></p>
              </li>
            </ul>
          </div>
          <img src="@/assets/images/Home/aml.png" alt="AML" />
        </div>
      </div>
      <div class="privacy content">
        <div>
          <h3>{{ $t('compliance.privacyTitle') }}</h3>
          <ul class="img-list">
            <li v-for="(item, index) in privacyItems" :key="item.title">
              <img :src="privacyIcons[index]" alt="Privacy" />
              <h5>{{ item.title }}</h5>
              <p v-html="item.desc"></p>
            </li>
          </ul>
        </div>
        <img src="@/assets/images/Compliance/privacy.png" alt="Privacy" />
      </div>
      <div class="licensed">
        <div class="content">
          <h3>{{ $t('compliance.licenseTitle') }}</h3>
          <p v-html="$t('compliance.licenseBody')"></p>
          <ul>
            <li v-for="(item, index) in licenses" :key="index">
              <img :src="licenseIcons[index]">
              <p>{{ item }}</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
  import gradientAnimation from '@/components/GradientAnimation'

  export default {
    name: 'Home',
    data() {
      return {
        height: window.innerHeight,
        serviceGranim: undefined,
        safeIcons: [
          require('@/assets/images/Home/safe-1.png'),
          require('@/assets/images/Home/safe-2.png'),
          require('@/assets/images/Home/safe-3.png'),
        ],
        privacyIcons: [
          require('@/assets/images/Compliance/privacy-1.png'),
          require('@/assets/images/Compliance/privacy-2.png'),
        ],
        licenseIcons: [
          require('@/assets/images/Compliance/MSB1.png'),
          require('@/assets/images/Compliance/MSO.png'),
          require('@/assets/images/Compliance/MSB2.png'),
        ],
      };
    },
    components: {
      gradientAnimation,
    },
    computed: {
      isEnglishLocale() {
        return this.$i18n.locale === 'en-US';
      },
      safeItems() {
        return this.$t('compliance.safeItems');
      },
      privacyItems() {
        return this.$t('compliance.privacyItems');
      },
      licenses() {
        return this.$t('compliance.licenses');
      },
    },
    mounted() {
      if (window.innerWidth < 1000) this.height = 0;
      window.addEventListener('resize', () => {
        if (window.innerWidth >= 1000) this.height = window.innerHeight;
      });

    },
  };
</script>

<style lang="less" scoped>
  .bodyFont(@bodyFontSize: 18px, @bodyLineHeight: 1.555555556, @fontWeightNormal: 300) {
    font: @fontWeightNormal @bodyFontSize/@bodyLineHeight "sohne-var", "Helvetica Neue", "Arial", sans-serif;
  }

  .button {
    height: auto;
    padding: 3px 0 6px;
    line-height: 1.6;
    .bodyFont(15px, 1.6, 425);
  }

  .service {
    position: relative;

    .content {
      display: flex;
      height: 843px;
      padding-bottom: 40px;

      & > div:first-child {
        width: 540px;
        margin-top: 184px;
        & > h1 {
          margin-bottom: 20px;
          color: white;
          font-size: 60px;
          font-weight: 500;
          line-height: 70px;
        }

        & > h2 {
          margin-bottom: 30px;
          color: white;
          font-size: 20px;
          font-weight: 200;
          line-height: 36px;

          & > span {
            font-weight: 400;
          }
        }

        .action {
          display: flex;

          .button {
            width: 122px;
            margin-right: 20px;
            background: #0070FF;

            &:last-child {
              width: auto;
              background: none;
            }

            &:hover {
              background: #0A2540;

              &:last-child {
                color: #BEBEBE;
                background: none;

                .arrow > i {
                  background: #BEBEBE;
                }
              }
            }
          }
        }
      }

      & > div:last-child {
        position: absolute;
        top: 219px;
        right: -8px;
        & > img {
          width: 566px;
          &:nth-child(2) {
            position: absolute;
            width: 600px;
            top: -17px;
            left: 110px;
          }
          &:last-child {
            position: absolute;
            width: 184px;
            bottom: 29px;
            left: 0px;
          }
        }
      }
    }
  }

  .safe {
    position: relative;
    margin-top: -100px;
    z-index: 2;

    &:before {
      background-color: white;
    }

    .content {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 120px 0 50px;

      & > div {

        & > h3 {
          margin-bottom: 10px;
          color: #082440;
          font-size: 36px;
          font-weight: 500;
          line-height: 54px;
        }

        & > p {
          width: 650px;
          margin-bottom: 30px;
          color: #092641;
          font-size: 20px;
          font-weight: 200;
          line-height: 36px;
          & > span {
            color: var(--spanColor1);
          }
        }
      }

      & > img {
        position: relative;
        bottom: -115px;
        height: 456px;
        margin-right: -48px;
      }
    }
  }

  .privacy {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 120px 0;

    & > div {

      & > h3 {
        margin-bottom: 30px;
        color: #082440;
        font-size: 36px;
        font-weight: 500;
        line-height: 54px;
      }
    }

    & > img {
      position: relative;
      bottom: -60px;
      height: 424px;
    }
  }

  .licensed {
    background: #F6F9FC;

    .content {
      padding: 120px 0 150px;

      & > h3 {
        margin-bottom: 10px;
        color: #082440;
        font-size: 36px;
        font-weight: 500;
        line-height: 54px;
      }

      & > p {
        width: 650px;
        margin-bottom: 30px;
        color: #092641;
        font-size: 20px;
        font-weight: 200;
        line-height: 36px;
        & > span {
          color: var(--spanColor1);
        }
      }

      & > ul {
        display: flex;

        & > li {
          display: flex;
          flex-direction: column;
          justify-content: center;
          margin-right: 50px;
          &:last-child {
            margin-right: 0;
          }

          & > p {
            font-size: 20px;
            font-weight: 400;
            color: #092641;
            line-height: 36px;
            text-align: center;
          }

          & > img {
            width: 360px;
            transition: all 0.3s;
            margin-bottom: 30px;
            border-radius: 16px;
            &:hover {
              box-shadow: 0 40px 80px -20px rgba(0, 0, 0, 0.3);
            }
          }
        }
      }
    }
  }

  @media screen and (max-width: 1000px) {
    .service {
      .bg1 {
        width: 189px;
      }

      .bg2 {
        width: 165px;
      }

      & > ul {
        bottom: 10px;

        & > li {
          margin: 0 5px;
          font-size: 12px;
        }
      }

    }

    .choice {
      padding: 32px 20px;

      & > h1 {
        margin-bottom: 32px;
      }

      & > ul {
        height: auto;
        flex-direction: column;

        & > li {
          position: relative;
          display: flex;
          flex-direction: column;
          justify-content: center;
          width: calc(100% - 30px);
          height: 125px;
          padding: 0 0 0 60px;
          border-right: none;
          border-bottom: 1px solid #E5E5E5;

          &:last-child {
            border-bottom: none;
          }

          & > i {
            position: absolute;
            top: 20px;
            left: 0;
          }

          & > h3 {
            font-size: 18px;
            margin-bottom: 5px;
          }

          & > span {
            line-height: 24px;
          }
        }
      }
    }

    .account {
      .content {
        padding: 32px 20px;

        .desc {
          margin-bottom: 0;
          padding: 20px 15px;
          flex-direction: column;
          align-items: flex-start;
          justify-content: center;

          & > div {
            width: auto;

            & > h1 {
              margin-bottom: 10px;
              font-size: 28px;
            }

            & > span {
              display: inline-block;
              margin-bottom: 20px;
              font-size: 18px;
              line-height: 28px;
            }
          }

          & > a {
            height: 32px;
            font-size: 14px;
            line-height: 32px;
            border-radius: 16px;
          }
        }

        .list {
          flex-direction: column;

          & > img {
            width: 100%;
            margin-left: 0;
            margin-bottom: -15px;
          }

          & > ul {
            flex-direction: column;
            margin-bottom: 0;

            & > li {
              width: 100%;
              margin-left: 0;
              margin-bottom: 20px;

              & > h3 {
                margin-bottom: 8px;
                font-size: 18px;
              }

              & > span {
                color: #72747D;
                line-height: 24px;
              }
            }
          }
        }
      }
    }

    .global {
      .bg1 {
        width: 228px;
      }

      .bg2 {
        width: 200px;
      }

      .content {
        padding: 40px 20px;

        & > h1 {
          margin-bottom: 36px;
        }

        .number {
          flex-wrap: wrap;
          justify-content: space-around;
          margin-bottom: 30px;

          & > li {
            width: 33.33333%;
            margin-bottom: 20px;
          }
        }

        .region {
          & > li {
            width: calc(50% - 8px);
            height: 34px;
            margin-bottom: 15px;
            padding-left: 10px;

            & > img {
              margin-right: 10px;
            }

            &:nth-child(n+5):nth-child(-n+10) {
              display: none;
            }

            &:empty {
              background: linear-gradient(180deg,#52597B 0%,#3B4368 100%);
              box-shadow: none;
            }
          }
        }

        & > a {
          width: 200px;
          height: 40px;
          margin: 0 auto 50px;
          line-height: 40px;
          border-radius: 20px;
        }

        & > h3 {
          width: auto;
          font-size: 18px;
          line-height: 28px;
        }
      }
    }

    /* 即将推出 */
    .coming {
      margin-bottom: 10px;
    }

    .card {
      position: relative;

      .bg1 {
        width: 230px;
      }

      .bg2 {
        width: 200px;
      }

      .content {
        flex-direction: column;
        justify-content: center;
        padding: 50px 20px;

        & > div {
          width: auto;

          & > h1 {
            margin-bottom: 10px;
          }

          & > p {
            margin-bottom: 26px;
            font-size: 18px;
          }

          & > ul {
            display: flex;
            justify-content: space-between;
            margin-bottom: 24px;

            & > li {
              width: calc(50% - 18px);

              & > h3 {
                margin-bottom: 8px;
                font-size: 18px;
              }

              & > span {
                font-size: 18px;
                line-height: 28px;
              }
            }
          }

          & > a {
            width: 200px;
            height: 40px;
            margin-bottom: 26px;
            line-height: 40px;
            border-radius: 20px;
          }
        }

        & > img {
          width: 100%;
        }
      }
    }

    .business {
      .content {
        flex-direction: column;
        justify-content: center;
        padding: 40px 20px;

        & > img {
          width: 100%;
          margin-bottom: 32px;
        }

        & > div {
          width: auto;

          & > h1 {
            margin-bottom: 10px;
          }

          & > p {
            font-size: 18px;
            line-height: 28px;
          }
        }
      }
    }

    .risk {
      .content {
        padding: 40px 20px;

        & > h1 {
          margin-bottom: 10px;
        }

        & > p {
          margin-bottom: 30px;
          font-size: 18px;
        }

        & > ul {
          flex-direction: column;
          padding: 20px 15px;

          & > li {
            width: 100%;
            height: auto;
            margin-bottom: 16px;
            padding: 0;
            border-right: none;

            &:last-child {
              margin-bottom: 0;
            }

            & > h3 {
              margin-bottom: 5px;

              & > span {
                display: inline;
              }

              & > br {
                display: none;
              }
            }

            & > span {
              line-height: 24px;
            }
          }
        }
      }
    }

    .partner {
      padding: 40px 0;
      & > h2 {
        margin-bottom: 30px;
      }
      & > ul {
        flex-wrap: wrap;
        justify-content: center;
        & > li {
          width: calc(33% - 8px);
          height: 43px;
          margin-bottom: 10px;
          & > img {
            max-width: 98px;
          }
        }
      }
    }

    .case {
      background: #3B4368;
      .content {
        padding: 60px 0;
        & > h1 {
          color: white;
          text-align: center;
          margin-bottom: 43px;
        }

        .showCase {
          height: 446px;
          & > li {
            display: flex;
            flex-direction: column;
            & > img {
              position: static;
              height: 261px;
            }
            & > div {
              position: static;
              padding: 20px 15px;
              width: 290px;
              & > p {
                &:nth-child(1) {
                  font-size: 18px;
                  margin-bottom: 23px;
                }
              }
            }
          }
        }

        .pages {
          margin-top: 40px;
        }
      }
    }

    .step {
      padding: 40px 20px 50px;

      & > h1 {
        margin-bottom: 26px;
      }

      & > ul {
        width: auto;

        & > li {
          height: 96px;
          margin-bottom: 15px;
          padding: 15px;
        }
      }
    }
  }

  @media screen and (max-width: 1000px) {
    .service .content {
      flex-direction: column;
      height: auto;
      padding: 110px 0 40px;

      & > div:first-child {
        width: 100%;
        margin-top: 0;

        & > h1,
        & > h1.is-en,
        & > h2 {
          max-width: none;
          text-align: center;
        }

        & > h1,
        & > h1.is-en {
          font-size: 34px;
          line-height: 1.18;
        }

        & > h2 {
          font-size: 18px;
          line-height: 30px;
        }

        .action {
          justify-content: center;
        }
      }

      & > div:last-child {
        position: relative;
        top: 0;
        right: 0;
        width: 100%;
        margin-top: 24px;
        display: flex;
        justify-content: center;
        transform: scale(0.78);
        transform-origin: top center;
      }
    }

    .safe .content,
    .privacy.content,
    .licensed .content > ul {
      flex-direction: column;
    }

    .safe .content,
    .privacy.content {
      padding: 80px 20px 40px;
    }

    .licensed .content {
      padding: 80px 20px 96px;
    }

    .safe .content > div > p,
    .licensed .content > p {
      width: auto;
      max-width: none;
    }

    .safe .content .img-list,
    .privacy.content .img-list {
      flex-direction: column;

      & > li {
        width: 100%;
        margin-right: 0;
        margin-bottom: 24px;
        padding-right: 0;

        &:last-child {
          margin-bottom: 0;
        }
      }
    }

    .safe .content > img,
    .privacy.content > img {
      position: static;
      width: 100%;
      max-width: 460px;
      height: auto;
      margin: 24px auto 0;
    }

    .licensed .content > ul > li {
      margin-right: 0;
      margin-bottom: 32px;

      & > img {
        width: 100%;
        max-width: 360px;
      }
    }
  }

  @media screen and (max-width: 768px) {
    .service .content {
      height: auto;
      min-height: auto;
      padding: 100px 16px 28px;
      flex-direction: column;

      & > div:first-child {
        width: 100%;
        margin-top: 0;

        & > h1 {
          max-width: none;
          margin-bottom: 16px;
          font-size: 24px;
          line-height: 1.25;
          text-align: center;
        }

        & > h1.is-en {
          font-size: 24px;
          line-height: 1.25;
        }

        & > h2 {
          margin-bottom: 24px;
          font-size: 15px;
          line-height: 1.75;
          text-align: left;
        }

        .action {
          flex-direction: column;
          align-items: center;
          gap: 12px;

          .button {
            width: 100%;
            max-width: 320px;
            margin: 0;
            height: auto;
            padding: 3px 0 6px;
            line-height: 1.6;
            font-size: 15px;
            font-weight: 425;

            &:last-child {
              width: auto;
              max-width: 320px;
            }
          }
        }
      }

      & > div:last-child {
        display: none;
      }
    }

    .safe {
      margin-top: 0;

      .content {
        flex-direction: column;
        padding: 64px 16px 32px;

        & > div {
          width: 100%;
          min-width: 0;

          & > h3 {
            margin-bottom: 12px;
            font-size: 24px;
            line-height: 1.3;
          }

          & > p {
            width: auto;
            max-width: none;
            margin-bottom: 20px;
            font-size: 15px;
            line-height: 1.6;
          }

          & .img-list {
            flex-direction: column;

            & > li {
              width: 100%;
              margin-right: 0;
              margin-bottom: 20px;
              padding-right: 0;

              &:last-child {
                margin-bottom: 0;
              }

              & > img {
                width: 36px;
                height: 36px;
                margin-bottom: 12px;
              }

              & > h5 {
                font-size: 15px;
                line-height: 22px;
              }

              & > p {
                font-size: 14px;
                line-height: 22px;
              }
            }
          }
        }

        & > img {
          display: none;
        }
      }
    }

    .privacy.content {
      flex-direction: column;
      align-items: stretch;
      width: 100%;
      padding: 64px 16px;

      & > div {
        width: 100%;
        min-width: 0;

        & > h3 {
          margin-bottom: 20px;
          font-size: 24px;
          line-height: 1.3;
        }

        & .img-list {
          flex-direction: column;

          & > li {
            width: 100%;
            margin-right: 0;
            margin-bottom: 20px;
            padding-right: 0;

            &:last-child {
              margin-bottom: 0;
            }

            & > img {
              width: 36px;
              height: 36px;
              margin-bottom: 12px;
            }

            & > h5 {
              font-size: 15px;
              line-height: 22px;
            }

            & > p {
              font-size: 14px;
              line-height: 22px;
            }
          }
        }
      }

      & > img {
        display: none;
      }
    }

    .licensed {
      .content {
        padding: 64px 16px 72px;

        & > h3 {
          margin-bottom: 12px;
          font-size: 24px;
          line-height: 1.3;
        }

        & > p {
          width: auto;
          max-width: none;
          margin-bottom: 24px;
          font-size: 15px;
          line-height: 1.6;
        }

        & > ul {
          flex-direction: column;
          align-items: center;

          & > li {
            width: 100%;
            max-width: 320px;
            margin-right: 0;
            margin-bottom: 28px;

            &:last-child {
              margin-bottom: 0;
            }

            & > img {
              width: 100%;
              max-width: 320px;
              margin-bottom: 12px;
            }

            & > p {
              font-size: 15px;
              line-height: 1.5;
            }
          }
        }
      }
    }
  }
</style>
